import Form from '@sendsprint/ui-react/dist/components/Form/formContainer';
import ClientApi from '@src/types/client';
import React from 'react';
import useRecurrentPaymentLinkForm from '../../hooks/useRecurrentPaymentLinkForm';
import PaymentLinkFormInner from './PaymentLinkFormInner';
import Dialog2, { Dialog2Header } from '@src/components/dialog2';

interface Props {
  isOpen: boolean;
  handleClose: () => void;
  paymentLinkObj?: ClientApi.General.PaymentLinkI | undefined;
  shouldRedirect?: boolean;
  frequency?: number;
  shouldShowDialog?: boolean;
  variant?: 'receiver' | 'raas';
}

export interface PaymentLinkFormII {
  linkName: string;
  amount: string;
  description: string;
  targetCurrency: string;
  interval: string | number;
  intervalCount: number | string;
  customerCanCancelSubscription: boolean;
  redirectUrl: string;
}

const RecurrentPaymentLinkForm = ({
  handleClose,
  isOpen,
  paymentLinkObj,
  shouldRedirect = true,
  shouldShowDialog,
  variant
}: Props) => {
  const paymentLinkResponse = useRecurrentPaymentLinkForm({
    handleClose,
    paymentLinkObj,
    shouldRedirect,
    variant
  });

  const { handleSubmit, initialValues, validationSchema, title } = paymentLinkResponse;
  return (
    <>
      {!shouldShowDialog && (
        <Form<PaymentLinkFormII>
          initialValues={initialValues}
          enableReinitialize
          validationSchema={validationSchema}
          onSubmit={handleSubmit}>
          <PaymentLinkFormInner variant={variant} paymentLinkResponse={paymentLinkResponse} />
        </Form>
      )}
      {shouldShowDialog && (
        <Dialog2 handleClose={handleClose} isOpen={isOpen} disableOverlayClick>
          <Dialog2Header handleClose={handleClose} label={title} />
          <Form<PaymentLinkFormII>
            initialValues={initialValues}
            enableReinitialize
            validationSchema={validationSchema}
            onSubmit={handleSubmit}>
            <PaymentLinkFormInner variant={variant} paymentLinkResponse={paymentLinkResponse} />
          </Form>
        </Dialog2>
      )}
    </>
  );
};

export default RecurrentPaymentLinkForm;
